// extracted by mini-css-extract-plugin
export default {"txhd":"HomeBottom_txhd__-Qvm0","txhd1":"HomeBottom_txhd1__-Diwp","points":"HomeBottom_points__t3oZ4"};